'use client'

import { AppliedFilters } from '@/features/catalog-brands/applied-filters'
import { BrandCategoriesList } from '@/features/catalog-brands/categories'
import { Filter, useBrandFilter } from '@/features/catalog-brands/filter'
import { CatalogDrawerFilter } from '@/features/catalog-shared/drawer-filter'

type DrawerFilterProps = {
	productCount: number
}

export const DrawerFilter = ({ productCount }: DrawerFilterProps) => {
	const controller = useBrandFilter()

	return (
		<CatalogDrawerFilter
			productCount={productCount}
			controller={controller}
			categoriesSlot={<BrandCategoriesList />}
			renderFilter={() => <Filter />}
			renderAppliedFilters={({ onChange, className }) => (
				<AppliedFilters onChange={onChange} className={className} clearInStart />
			)}
		/>
	)
}
